import React, { useEffect, useState } from "react";
import doc5Service from "../../../services/doc5.service";
import Loadding from "../../common/loadding";
import { Tooltip } from "antd";

const GroupCheck = (props: { group: string; doc3Id: number; type:string; }) => {
  const { group, doc3Id,type } = props;
  const [status, setStatus] = useState(false);
  const [send, setSend] = useState(false);

  useEffect(() => {
    (async () => {
      doc5Service.checkStatusSend(doc3Id, group).then((res) => {
        if (res.data === "") {
          setSend(true);
        }
        setStatus(true);
      });
    })();
  }, []);

  if (!status) {
    return <Loadding />;
  }

  if (send) {
    return (
      <>
        <h6>
        <Tooltip title={`ยังไม่ส่ง ${type}5`}
          placement={'right'}>
          <span className="badge bg-danger rounded-pill">
            <i className="bi bi-x-circle" /> {group}
          </span></Tooltip>
        </h6>
      </>
    );
  } else {
    return (
      <>
        <h6>
          <span className="badge bg-success rounded-pill">
            <i className="bi bi-check2-circle" /> {group}
          </span>
        </h6>
      </>
    );
  }
};

export default GroupCheck;
